<template>
  <div class="kpt-context-pane">
    <notifications-context-pane v-if="contextPane == 'notifications'" :close="closeContextPane"></notifications-context-pane>
    <feedback-context-pane v-if="contextPane == 'feedback'" :close="closeContextPane"></feedback-context-pane>
    <support-context-pane v-if="contextPane == 'support'" :close="closeContextPane"></support-context-pane>
    <column-editor-component v-if="contextPane == 'columnEditor'" :close="closeContextPane"></column-editor-component>
    <subscription-report v-if="contextPane == 'subscriptionReport'" :close="closeContextPane"></subscription-report>
  </div>
</template>
<script>
import NotificationsContextPane from '../system/notifications/NotificationsContextPane.vue';
import FeedbackContextPane from '../system/FeedbackContextPane.vue';
import ColumnEditorComponent from '../shared/ColumnEditorComponent.vue';
import SupportContextPane from '../system/SupportContextPange.vue';
import SubscriptionReport from '../subscriptions/components/SubscriptionReportExport.vue';

export default {
  components: {
    NotificationsContextPane,
    SupportContextPane,
    FeedbackContextPane,
    ColumnEditorComponent,
    SubscriptionReport
  },
  computed: {
    contextPane() {
      // KyAnalytics client plugin, event tracker
      if (this.$store.state.system.contextPane) this.$kya.event('system', 'paneOpen', 'Context pane opened', { contextPane: this.$store.state.system.contextPane });
      return this.$store.state.system.contextPane;
    }
  },
  methods: {
    closeContextPane() {
      this.$store.commit('setContextPane', null)
    }
  }
}
</script>
<style lang="scss">
@import '../styles/_colors';
.kpt-context-pane {
  position: absolute;
  right: 0;
  height: 100%;
  min-width: 315px;
  z-index: 9;
  box-shadow: 0 8px 16px 0 rgba(0,0,0,.15);

  .kpt-context-pane-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .kpt-context-pane-header {
    display: flex;
    justify-content: space-between;
    padding: 0.75rem;
    background: $white-ter;
    border-bottom: 1px solid $grey-lighter;
  }

  .kpt-context-pane-main {
    padding: 0.75rem;
    flex: 1 1 auto;
    overflow-y: auto;
  }

  .kpt-context-pane-footer {
    padding: 0.75rem;
  }
}
</style>
